import React, { useState } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { FiClock } from 'react-icons/fi';

import TimelineProtocolHistory from '../TimelineProtocolHistory';

const ProtocolHistoryModal = (props) => {
  const { protocolId, className = '' } = props;
  const [modal, setModal] = useState(false);

  const toggle = () => setModal(!modal);

  return (
    <div>
      <Button color="success" onClick={toggle} size="sm">
        <FiClock size={17} />
      </Button>
      <Modal isOpen={modal} toggle={toggle} className={`modal-lg ${className}`}>
        <ModalHeader toggle={toggle}>Histórico do protocolo</ModalHeader>
        <ModalBody>
          <TimelineProtocolHistory protocolId={protocolId} />
        </ModalBody>
        <ModalFooter>
          <Button color="danger" onClick={toggle}>
            Fechar
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default ProtocolHistoryModal;
